import { fetchAsyncData } from 'components.modules.gen/placeholder-dataurl/fetchDataAsync.js';
import { IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { IPageConfig } from 'redux-state/layout/types.page.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { objectAssignTypeSafety } from 'utilities/helpers/objects.js';

export const getTargetedAdsUrl = async (
  advertising: IPageConfig<'Raw'>['advertising'],
): Promise<IPageConfig<'Raw'>['advertising']> => {
  const path = advertising.targeting?.dynamicDataUrl;
  if (path) {
    messageLog.error('Requesting Targeting Data');
    const result = await fetchAsyncData<IApiAdTargeting[]>({ url: path });
    if (result.responseOK) {
      const mergedTargetedData = [...(advertising.targeting?.staticData ?? []), ...result.jsonData];
      const mergedTargeted = objectAssignTypeSafety(advertising.targeting, { staticData: mergedTargetedData });
      const mergedAds = objectAssignTypeSafety(advertising, { targeting: mergedTargeted });
      return mergedAds;
    } else {
      console.error(`Unable to get targeting ads data ${path}`);
      return advertising;
    }
  }
  return advertising;
};
